export default "__VITE_ASSET__0958c5e7__"